import React from "react";
import Navbar from "../pages/Navbar";
import "../styles/home.css";
import kslogo from "../images/kslogo.jpg";

const Home = () => {
    return (
        <div className="page-wrapper">
            <Navbar />

            <div className="krishtech">
                <div className="krishtech1">
                    <h1>Welcome to KrishTech Software</h1>
                    <p>
                        At KrishTech Software, we specialize in building innovative, scalable, and secure digital solutions that empower businesses to thrive in today’s fast-paced world. From custom software development and cloud integration to mobile applications and enterprise systems,
                        our team combines technical expertise with creative problem-solving to deliver results that drive growth. With a commitment to quality, transparency, and client success, we transform ideas into powerful tools that make a real impact. We are delivering innovative software solutions for modern businesses - Your IT Friend.
                    </p>
                </div>
            </div>


            <main>
                <section className="page-section" id="why-choose-us">
                    <h2 className="service-card">Why Choose Us?</h2>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Expert Team</h3>
                            <p>Our experienced developers and designers bring years of industry expertise.</p>
                        </div>
                        <div className="service-card">
                            <h3>Quality Assurance</h3>
                            <p>Rigorous testing ensures your software is reliable and bug-free.</p>
                        </div>
                        <div className="service-card">
                            <h3>Timely Delivery</h3>
                            <p>We respect deadlines and deliver projects on schedule.</p>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <div className="text_style">
                    <p>&copy; 2026 KrishTech Software - Your IT Friend. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home;
